import styled from 'styled-components';

export const StyledFrame = styled.iframe`
   height: 100%;
   width: 100%;
   border: none;
`;

StyledFrame.displayName = 'StyledFrame';
